"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { Controller } from "@hotwired/stimulus";
export default class controller_default extends Controller {
  toggle() {
    this.setOpen(this.menuTarget.dataset.open !== "true");
  }
  closeOutside(event) {
    if (!this.element.contains(event.target)) {
      this.setOpen(false);
    }
  }
  setOpen(open) {
    this.menuTarget.dataset.open = String(open);
    this.triggerTarget.setAttribute("aria-expanded", String(open));
  }
}
__publicField(controller_default, "targets", ["trigger", "menu"]);
